import type { LinePool } from "../ui/companion/machine.ts";
import { COMPANION_LINES_EN, companionEn } from "./companion.en.ts";
import { translate } from "./lang.ts";

/**
 * What the companion says, per situation. Same house style as vi.ts:
 * playful, warm, never mocking; no dashes, dots, slashes, symbols or
 * parentheses. One line is drawn at random, avoiding the last one shown.
 * English twin in `companion.en.ts`.
 */
export const COMPANION_LINES: Record<LinePool, readonly string[]> = translate<Record<LinePool, readonly string[]>>({
  start: [
    "Cùng phá màn này nha, mình cổ vũ hết mình luôn!",
    "Sẵn sàng chưa nè? Mình ngồi đây hóng bạn tỏa sáng nha!",
    "Màn mới tới rồi! Cứ thong thả mà chơi nha.",
    "Mình mang theo cả rổ may mắn cho bạn rồi đó!",
    "Hít một hơi thật sâu, rồi mình quẩy thôi!",
  ],
  combo: [
    "Ui, đúng liền một mạch luôn! Bạn đỉnh quá trời!",
    "Tay bạn có phép thuật hả? Đúng hoài luôn á!",
    "Chuỗi đẹp ghê! Giữ phong độ nha!",
    "Mình vỗ tay muốn rát cả tay rồi nè!",
    "Nhanh gọn lẹ, chuẩn không cần chỉnh!",
  ],
  bin: [
    "Xong thêm một chỗ rồi! Gọn gàng ghê chưa!",
    "Thêm một góc ngăn nắp nữa, tuyệt cú mèo!",
    "Đầy ắp rồi kìa, mình mê quá à!",
  ],
  phase: [
    "Ơ kìa, có gì đó vừa đổi khác! Ngó kỹ xíu nha!",
    "Phép màu vừa bật lên rồi đó! Xem luật mới nè!",
  ],
  oops: [
    "Hụt xíu thôi, không sao hết nha!",
    "Ối, chỗ đó chưa đúng. Thử chỗ khác xem!",
    "Trật một xíu à, mình vẫn tin bạn nè!",
  ],
  oopsAgain: [
    "Hít sâu một hơi, rồi mình làm lại nha.",
    "Từ từ thôi, nhìn kỹ rồi hẵng thả nha.",
    "Mình cũng hay nhầm lắm, bạn đừng lo!",
  ],
  cry: [
    "Huhu, mình thương bạn quá. Nghỉ xíu rồi thử lại nha!",
    "Không sao đâu, nhầm hoài rồi cũng sẽ đúng mà!",
    "Mình khóc xíu thôi, rồi mình cùng cố tiếp nha!",
  ],
  comeback: [
    "Đó đó! Đúng rồi nè, biết ngay mà!",
    "Lấy lại phong độ rồi! Tuyệt quá đi!",
    "Thấy chưa, bạn làm được mà!",
  ],
  undo: [
    "Lùi một bước để nhảy xa hơn nha!",
    "Nghĩ lại cũng được, nghĩ kỹ là thắng!",
  ],
  hint: [
    "Để mình ngó thử nha, chỗ này nè!",
    "Bóng đèn sáng rồi! Nhìn theo tia lấp lánh nha.",
  ],
  sleepy: [
    "Oáp, bạn ơi, mình buồn ngủ quá à.",
    "Mình chợp mắt xíu nha, có gì gọi mình dậy nha.",
    "Bạn đang nghĩ kế hay ha? Mình chờ nè.",
  ],
  wake: [
    "Á, mình thức rồi nè! Tiếp tục thôi!",
    "Ủa mình ngủ quên hả? Hihi, chơi tiếp nha!",
  ],
  win3: [
    "Hoàn hảo luôn! Bạn là thiên tài đó hả?",
    "Ba sao lấp lánh! Mình tự hào về bạn quá!",
    "Đỉnh của chóp! Rinh ba sao về nhà thôi!",
  ],
  win: [
    "Xong rồi nè! Lần sau mình rinh thêm sao nha!",
    "Qua màn rồi! Bạn giỏi lắm luôn á!",
    "Phù, làm được rồi! Mình mừng quá đi!",
  ],
  poke: [
    "Hihi, nhột quá à!",
    "Mình đây nè, bạn cần gì hông?",
    "Chọc mình hoài, tập trung chơi đi nè!",
    "Cố lên cố lên, mình cổ vũ nè!",
  ],
}, COMPANION_LINES_EN);

export const companionVi = translate(
  {
    settingLabel: "Bạn đồng hành trong màn chơi",
    settingNote: "Nhân vật của bạn ngồi ở góc màn hình, vui buồn cùng bạn.",
    pokeLabel: "Bạn đồng hành",
  },
  companionEn,
);
